module.exports = __webpack_public_path__ + "img/refund.3b22e4ce.svg";